import { StoreProductType } from 'v2/constants';

export const SPECIAL_REWARDS = [StoreProductType.GOLDEN_TICKET, StoreProductType.PROMOCODE];
